import { messages as roomStructureMessages } from '../views/room/roomStructureLang'
import { messages as carStructureMessages } from '../views/car/carStructureLang'
import { messages as propertyRightRegistrationManageMessages } from '../views/room/propertyRightRegistrationManageLang'
import { messages as listPropertyRightRegistrationDetailMessages } from '../views/room/listPropertyRightRegistrationDetailLang'
import { messages as communityPublicityManageMessages } from '../views/community/communityPublicityManageLang'
import { messages as addCommunityPublicityMessages } from '../views/community/addCommunityPublicityLang'
import { messages as electricMeterMessages } from '../views/community/electricMeterManageLang'
import { messages as editCommunityPublicityMessages } from '../views/community/editCommunityPublicityLang'
import { messages as handoverMessages } from '../views/room/handoverLang'
import { messages as ownerExitRoomMessages } from '../views/room/ownerExitRoomLang'
import { messages as adminRoomDetailMessages } from '../views/aCommunity/adminRoomDetailLang.js'
import { messages as adminOwnerDetailMessages } from '../views/aCommunity/adminOwnerDetailLang.js'
import { messages as adminCarDetailMessages } from '../views/aCommunity/adminCarDetailLang.js'
import { messages as adminFeeDetailMessages } from '../views/aCommunity/adminFeeDetailLang.js'
import { messages as listRoomDecorationRecordMessages } from '../views/community/listRoomDecorationRecordLang'
import { messages as listRoomRenovationRecordDetailsMessages } from '../views/community/listRoomRenovationRecordDetailsLang'
import { messages as wechatSubscribeMessages } from '../views/community/wechatSubscribeLang'
export const messages = {
    en: {
        ...roomStructureMessages.en,
        ...carStructureMessages.en,
        ...propertyRightRegistrationManageMessages.en,
        ...listPropertyRightRegistrationDetailMessages.en,
        ...communityPublicityManageMessages.en,
        ...addCommunityPublicityMessages.en,
        ...editCommunityPublicityMessages.en,
        ...handoverMessages.en,
        ...ownerExitRoomMessages.en,
        ...adminRoomDetailMessages.en,
        ...adminOwnerDetailMessages.en,
        ...adminCarDetailMessages.en,
        ...adminFeeDetailMessages.en,
        ...listRoomDecorationRecordMessages.en,
        ...listRoomRenovationRecordDetailsMessages.en,
        ...wechatSubscribeMessages.en,
    },
    zh: {
        ...roomStructureMessages.zh,
        ...carStructureMessages.zh,
        ...propertyRightRegistrationManageMessages.zh,
        ...listPropertyRightRegistrationDetailMessages.zh,
        ...communityPublicityManageMessages.zh,
        ...addCommunityPublicityMessages.zh,
        ...electricMeterMessages.zh,
        ...handoverMessages.zh,
        ...ownerExitRoomMessages.zh,
        ...adminRoomDetailMessages.zh,
        ...adminOwnerDetailMessages.zh,
        ...adminCarDetailMessages.zh,
        ...adminFeeDetailMessages.zh,
        ...listRoomDecorationRecordMessages.zh,
        ...listRoomRenovationRecordDetailsMessages.zh,
        ...wechatSubscribeMessages.zh,
    }
}